import fetcher from 'lib/fetcher';
import { IEstimatePrimaryRequest, IPrimaryFacilityEstimateResponse } from 'screens/estimate/interfaces';
import useSWRMutation from 'swr/mutation';

const LAST_MESSAGE =
  'Произошла техническая ошибка, оставте заявку чтобы мы смогли ее исправить';

const useEstimatePrimary = () => {
  async function fetchEstimateSPrimary(url: string, { arg }: { arg: IEstimatePrimaryRequest }) {
    try {
      const data = await fetcher.post(url, arg);

      if (data?.error) {
        throw LAST_MESSAGE;
      }

      return data.result as IPrimaryFacilityEstimateResponse;
    } catch (error) {
      throw LAST_MESSAGE;
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    '/facilities/estimate-primary',
    fetchEstimateSPrimary,
  );

  return { data, error, isMutating, trigger };
};
export default useEstimatePrimary;
